import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-3" }
const _hoisted_2 = {
  class: "mb-3",
  style: {"text-align":"center"}
}
const _hoisted_3 = { style: {"font-weight":"bold","margin-bottom":"4px","text-transform":"uppercase"} }
const _hoisted_4 = { style: {"margin-bottom":"0","font-style":"italic"} }
const _hoisted_5 = {
  class: "hop-dong-viewer__info",
  style: {"font-size":"0.9rem","margin-bottom":"1.25rem"}
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { style: {"font-weight":"bold","margin-bottom":"8px"} }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"border-bottom":"1px solid #000","padding-bottom":"3px"} }, " I. Thông tin hợp đồng: ")
], -1)
const _hoisted_7 = { style: {"padding-left":"1.5rem"} }
const _hoisted_8 = { style: {"display":"flex","flex-direction":"row","margin-bottom":"6px"} }
const _hoisted_9 = { style: {"flex":"1","margin":"0"} }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("strong", null, "Mã hợp đồng:", -1)
const _hoisted_11 = { style: {"margin-left":"8px"} }
const _hoisted_12 = { style: {"flex":"1","margin":"0"} }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("strong", null, "Loại HĐ:", -1)
const _hoisted_14 = { style: {"margin-left":"8px"} }
const _hoisted_15 = { style: {"display":"flex","flex-direction":"row","margin-bottom":"6px"} }
const _hoisted_16 = { style: {"flex":"1","margin":"0"} }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("strong", null, "Số hoá đơn:", -1)
const _hoisted_18 = { style: {"margin-left":"8px"} }
const _hoisted_19 = { style: {"flex":"1","margin":"0"} }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("strong", null, "Mã số thuế:", -1)
const _hoisted_21 = { style: {"margin-left":"8px"} }
const _hoisted_22 = { style: {"display":"flex","flex-direction":"row","margin-bottom":"6px"} }
const _hoisted_23 = { style: {"flex":"1","margin":"0"} }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("strong", null, "Tên đối tác:", -1)
const _hoisted_25 = { style: {"margin-left":"8px"} }
const _hoisted_26 = { style: {"flex":"1","margin":"0"} }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("strong", null, "Số điện thoại:", -1)
const _hoisted_28 = { style: {"margin-left":"8px"} }
const _hoisted_29 = { style: {"display":"flex","flex-direction":"row","margin-bottom":"6px"} }
const _hoisted_30 = { style: {"flex":"1","margin":"0"} }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("strong", null, "Ngày ký:", -1)
const _hoisted_32 = { style: {"margin-left":"8px"} }
const _hoisted_33 = { style: {"flex":"1","margin":"0"} }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("strong", null, "Ngày hết hạn:", -1)
const _hoisted_35 = { style: {"margin-left":"8px"} }
const _hoisted_36 = { style: {"margin-bottom":"6px"} }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("strong", null, "Địa chỉ:", -1)
const _hoisted_38 = { style: {"margin-left":"8px"} }
const _hoisted_39 = { style: {"margin-bottom":"6px"} }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("strong", null, "Hoàn thành:", -1)
const _hoisted_41 = { style: {"margin-left":"8px"} }
const _hoisted_42 = { style: {"margin-bottom":"0"} }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("strong", null, "Tổng giá trị:", -1)
const _hoisted_44 = { style: {"margin-left":"8px"} }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("p", { style: {"font-weight":"bold","margin-bottom":"8px","font-size":"0.9rem"} }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"border-bottom":"1px solid #000","padding-bottom":"3px"} }, " II. Danh sách vật tư: ")
], -1)
const _hoisted_46 = {
  class: "pdf-print-table",
  style: {"font-size":"0.75rem","margin-bottom":"1rem"}
}
const _hoisted_47 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"5%"} }, "STT"),
    /*#__PURE__*/_createElementVNode("th", null, "Tên"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"11%"} }, "Mã"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"7%"} }, "ĐVT"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"7%"} }, "Thu hồi"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"8%"} }, "C/ty QL"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"10%"} }, "SL HĐ"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"12%"} }, "Đơn giá"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"14%"} }, "Thành tiền")
  ])
], -1)
const _hoisted_48 = { style: {"text-align":"left"} }
const _hoisted_49 = { style: {"text-align":"center"} }
const _hoisted_50 = { style: {"text-align":"center"} }
const _hoisted_51 = { style: {"text-align":"center"} }
const _hoisted_52 = { style: {"text-align":"center"} }
const _hoisted_53 = { style: {"text-align":"right"} }
const _hoisted_54 = { style: {"text-align":"right"} }
const _hoisted_55 = { style: {"text-align":"right"} }
const _hoisted_56 = {
  key: 0,
  class: "pdf-print-table-data-row"
}
const _hoisted_57 = /*#__PURE__*/_createElementVNode("td", {
  colspan: "9",
  style: {"text-align":"center"}
}, "Chưa có vật tư", -1)
const _hoisted_58 = [
  _hoisted_57
]
const _hoisted_59 = {
  key: 1,
  class: "pdf-print-table-total-row"
}
const _hoisted_60 = /*#__PURE__*/_createElementVNode("td", {
  colspan: "8",
  style: {"text-align":"right"}
}, [
  /*#__PURE__*/_createElementVNode("strong", null, "Tổng cộng")
], -1)
const _hoisted_61 = { style: {"text-align":"right"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PdfDocumentHeader = _resolveComponent("PdfDocumentHeader")!
  const _component_PdfViewerPage = _resolveComponent("PdfViewerPage")!

  return (_openBlock(), _createBlock(_component_PdfViewerPage, {
    title: "Chi tiết hợp đồng",
    "title-suffix": _ctx.hopDong?.so_hop_dong,
    count: _ctx.vatTuItems.length,
    "count-label": "vật tư",
    source: _ctx.pdfSource,
    "file-name": _ctx.pdfFileName,
    loading: _ctx.isGenerating,
    "fallback-route-name": "chi-tiet-hop-dong"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        ref: "printArea",
        class: "hop-dong-viewer__hidden-template",
        style: _normalizeStyle(_ctx.hiddenTemplateStyle),
        "aria-hidden": "true"
      }, [
        (_ctx.hopDong)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "printing-paper",
              style: _normalizeStyle(_ctx.printPaperStyle)
            }, [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_PdfDocumentHeader, {
                  "ten-don-vi": _ctx.tenDonVi,
                  "ten-don-vi-cha": _ctx.tenDonViCha
                }, null, 8, ["ten-don-vi", "ten-don-vi-cha"])
              ]),
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("h4", _hoisted_3, _toDisplayString(_ctx.documentTitle), 1),
                _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.ngayKyLongDisplay), 1)
              ]),
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("p", _hoisted_9, [
                      _hoisted_10,
                      _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.hopDong.so_hop_dong || "-"), 1)
                    ]),
                    _createElementVNode("p", _hoisted_12, [
                      _hoisted_13,
                      _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.loaiHopDongDisplay), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("p", _hoisted_16, [
                      _hoisted_17,
                      _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.hopDong.so_hoa_don || "-"), 1)
                    ]),
                    _createElementVNode("p", _hoisted_19, [
                      _hoisted_20,
                      _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.hopDong.ma_so_thue || "-"), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("p", _hoisted_23, [
                      _hoisted_24,
                      _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.hopDong.ten_doi_tac || "-"), 1)
                    ]),
                    _createElementVNode("p", _hoisted_26, [
                      _hoisted_27,
                      _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.hopDong.so_dien_thoai || "-"), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("p", _hoisted_30, [
                      _hoisted_31,
                      _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.ngayKyDisplay), 1)
                    ]),
                    _createElementVNode("p", _hoisted_33, [
                      _hoisted_34,
                      _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.ngayHetHanDisplay), 1)
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_36, [
                    _hoisted_37,
                    _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.hopDong.dia_chi || "-"), 1)
                  ]),
                  _createElementVNode("p", _hoisted_39, [
                    _hoisted_40,
                    _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.isHoanThanh ? "Có" : "Chưa"), 1)
                  ]),
                  _createElementVNode("p", _hoisted_42, [
                    _hoisted_43,
                    _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.formatAmount(_ctx.totalThanhTien)), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_45,
                _createElementVNode("table", _hoisted_46, [
                  _hoisted_47,
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vatTuItems, (vatTu, index) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: vatTu.id_vat_tu || vatTu.id,
                        class: _normalizeClass({
                  'pdf-print-table-data-row': true,
                  'pdf-print-table-data-row--last':
                    index === _ctx.vatTuItems.length - 1,
                })
                      }, [
                        _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                        _createElementVNode("td", _hoisted_48, _toDisplayString(vatTu.ten_vat_tu), 1),
                        _createElementVNode("td", _hoisted_49, _toDisplayString(vatTu.ma_vat_tu), 1),
                        _createElementVNode("td", _hoisted_50, _toDisplayString(vatTu.don_vi_tinh || "-"), 1),
                        _createElementVNode("td", _hoisted_51, _toDisplayString(_ctx.checkboxMark(!!vatTu.thu_hoi)), 1),
                        _createElementVNode("td", _hoisted_52, _toDisplayString(_ctx.checkboxMark(!!vatTu.cong_ty_duyet)), 1),
                        _createElementVNode("td", _hoisted_53, _toDisplayString(_ctx.formatQuantity(vatTu.so_luong_trong_hop_dong)), 1),
                        _createElementVNode("td", _hoisted_54, _toDisplayString(_ctx.formatUnitPrice(vatTu.don_gia)), 1),
                        _createElementVNode("td", _hoisted_55, [
                          _createElementVNode("strong", null, _toDisplayString(_ctx.formatAmount(
                      _ctx.calcLineAmount(
                        vatTu.don_gia,
                        vatTu.so_luong_trong_hop_dong
                      )
                    )), 1)
                        ])
                      ], 2))
                    }), 128)),
                    (!_ctx.vatTuItems.length)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_56, _hoisted_58))
                      : _createCommentVNode("", true),
                    (_ctx.vatTuItems.length)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_59, [
                          _hoisted_60,
                          _createElementVNode("td", _hoisted_61, [
                            _createElementVNode("strong", null, _toDisplayString(_ctx.formatAmount(_ctx.totalThanhTien)), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ], 4))
          : _createCommentVNode("", true)
      ], 4)
    ]),
    _: 1
  }, 8, ["title-suffix", "count", "source", "file-name", "loading"]))
}